import React, { useEffect, useCallback } from 'react';
import { useSettingsModal } from '../../contexts/SettingsModalContext';
import { SettingsModal } from './SettingsModal';
import { CampaignProvider } from '../../contexts/CampaignContext';

export const GlobalSettingsModal: React.FC = () => {
  const { isOpen, initialSection, initialMonitorId, closeSettings, openSettings } = useSettingsModal();

  useEffect(() => {
    const settingsTab = new URLSearchParams(window.location.search).get('settings');
    if (settingsTab && !isOpen) {
      openSettings(settingsTab);
    }
  }, [openSettings, isOpen]);

  const handleSectionChange = useCallback((section: string) => {
    const params = new URLSearchParams(window.location.search);
    params.set('settings', section);
    window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);
  }, []);

  return (
    <CampaignProvider>
      <SettingsModal
        isOpen={isOpen}
        onClose={closeSettings}
        initialSection={initialSection}
        initialMonitorId={initialMonitorId}
        onSectionChange={handleSectionChange}
      />
    </CampaignProvider>
  );
};
